import { privateRequest, type ApiResponse } from "../axios";

// export interface WhatsAppTemplate {
//   TemplateId: number;
//   CompanyId: number;
//   TemplateName: string;
//   LanguageCode: string;
//   BodyFormat: string;
//   IsActive: boolean;
// }


const ENDPOINTS = {
  HISTORY: "API/Message/getMessage",
  SEND: "api/Message/send",
  GET_FILE :"api/Message/downloadMedia",
  GET_TEMPLATE: "API/Message/whatsAppTemplates"
};

const getWhatsAppHistory = async (data: any):Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.HISTORY}?phoneNumber=${data.phone}&page=${data.page}&pageSize=${data.pageSize}`
  );
  return res.data;
};

const sendWhatsAppMessage = async ( data: any):Promise<ApiResponse<any>> => {
  
  const formData = new FormData();
  formData.append("Data", JSON.stringify(data.payload || data));
  if (data.selectedFile) {
    formData.append("files", data.selectedFile);
  }
  // const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.SEND, data);
  const res = await privateRequest.post(
    ENDPOINTS.SEND,
    formData,
  );
  return res.data;
};


const getFile = async (data: any) => {
  const res = await privateRequest.get(
    `${ENDPOINTS.GET_FILE}/${data.mediaId}`,{responseType:"blob"}
  );
  return res.data;
};

const getTemplate = async (): Promise<ApiResponse<any[]>> => {  
    const res = await privateRequest.get<ApiResponse<any[]>>(
        ENDPOINTS.GET_TEMPLATE
    );
    return res.data;
}

const WhatsAppService = {
  getWhatsAppHistory,
  sendWhatsAppMessage,
  getFile,
  getTemplate,
};

export default WhatsAppService;
